// The brain map for the chat players (components/BrainThink.js via
// HowIKnew's Watch): GET /brain/pages?stratum=map — the merged graph of
// every stratum this seat may read (shared/brainView.brainMap). Fetched
// once per page load, on first watch; null when the seat has no brain to
// read, and the player degrades to the stage ribbon + sources rail.
// Tenant: the backend falls back to the instance's default org when no
// x-nventr-org header rides along, which is every single-org instance.
// [[watch-the-brain-think]]
import { getIdToken } from './authPlane';
import { kitEnv } from './kitEnv';

const API = kitEnv('UPLOAD_API', process.env.REACT_APP_UPLOAD_API || '');
let cached = null;

export async function loadBrainGraph() {
  if (cached) return cached;
  cached = (async () => {
    try {
      const token = await getIdToken();
      const res = await fetch(`${API}/brain/pages?stratum=map`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
      if (!res.ok) return null;
      const g = await res.json();
      return g?.nodes?.length ? g : null;
    } catch {
      return null;
    }
  })();
  const g = await cached;
  if (!g) cached = null; // try again next time (sign-in may have settled)
  return g;
}

// Where the full Think view lives on this instance.
export const THINK_HREF = '/brain?view=think';
